<template>
  <v-form
    ref="form"
    @submit.prevent
    :value="valid"
    @input="v => $emit('update:valid', v)"
  >
    <v-row no-gutters>
      <v-select
        label="Lundi"
        filled
        class="no-before"
        :value="monday"
        @change="v => $emit('update:monday', v)"
        :items="getPreparationSlipTemplates"
        item-text="name"
        item-value="id"
      ></v-select>
    </v-row>
    <v-row no-gutters>
      <v-select
        label="Mardi"
        filled
        class="no-before"
        :value="tuesday"
        @change="v => $emit('update:tuesday', v)"
        :items="getPreparationSlipTemplates"
        item-text="name"
        item-value="id"
      ></v-select>
    </v-row>
    <v-row no-gutters>
      <v-select
        label="Mercredi"
        filled
        class="no-before"
        :value="wednesday"
        @change="v => $emit('update:wednesday', v)"
        :items="getPreparationSlipTemplates"
        item-text="name"
        item-value="id"
      ></v-select>
    </v-row>
    <v-row no-gutters>
      <v-select
        label="Jeudi"
        filled
        class="no-before"
        :value="thursday"
        @change="v => $emit('update:thursday', v)"
        :items="getPreparationSlipTemplates"
        item-text="name"
        item-value="id"
      ></v-select>
    </v-row>
    <v-row no-gutters>
      <v-select
        label="Vendredi"
        filled
        class="no-before"
        :value="friday"
        @change="v => $emit('update:friday', v)"
        :items="getPreparationSlipTemplates"
        item-text="name"
        item-value="id"
      ></v-select>
    </v-row>
    <v-row no-gutters>
      <v-select
        label="Samedi"
        filled
        class="no-before"
        :value="saturday"
        @change="v => $emit('update:saturday', v)"
        :items="getPreparationSlipTemplates"
        item-text="name"
        item-value="id"
      ></v-select>
    </v-row>
    <v-row no-gutters>
      <v-select
        label="Dimanche"
        filled
        class="no-before"
        :value="sunday"
        @change="v => $emit('update:sunday', v)"
        :items="getChoices"
        item-text="name"
        item-value="id"
      ></v-select>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DefaultDailyPrepSlipFields",
  props: {
    monday: {
      required: true
    },
    tuesday: {
      required: true
    },
    wednesday: {
      required: true
    },
    thursday: {
      required: true
    },
    friday: {
      required: true
    },
    saturday: {
      required: true
    },
    sunday: {
      required: true
    },
    valid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getPreparationSlipTemplates"]),
    getChoices() {
      return [...this.getPreparationSlipTemplates, { name: "", id: null }];
    }
  }
};
</script>

<style></style>
